if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data.variant;
    const sectionId = event.data.sectionId;
    if (!variant || !Array.isArray(variant.options)) return;

    const isXXL = variant.options.some((value) => typeof value === 'string' && value.includes('XXL'));
    if (!isXXL) return;

    const mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
    mediaGallery?.setActiveMedia?.(`${sectionId}-ext-8`, true);
  });
}
